import { AnimatePresence, motion } from "framer-motion";

export default function Lightbox({ item, onClose }) {
  return (
    <AnimatePresence>
      {item && (
        <motion.div
          data-testid="artwork-lightbox"
          className="fixed inset-0 z-[95] bg-ink/95 backdrop-blur-sm flex items-center justify-center p-4 md:p-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <button
            data-testid="lightbox-close"
            aria-label="Close"
            onClick={onClose}
            className="absolute top-5 right-6 text-paper/80 hover:text-alta text-4xl font-light z-10 transition-colors"
          >
            ×
          </button>
          <motion.div
            className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-12 gap-6 items-center max-h-full overflow-y-auto"
            initial={{ scale: 0.94, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="md:col-span-8 kantha-border p-2 bg-bone/5">
              <img src={item.image} alt={item.title} className="w-full max-h-[75vh] object-contain" />
            </div>
            <div className="md:col-span-4 text-paper">
              <p className="text-[10px] tracking-[0.3em] uppercase text-alta mb-4">{item.category}</p>
              <h3 className="font-serif text-3xl md:text-4xl font-light">{item.title}</h3>
              <p className="mt-3 text-xs tracking-[0.2em] uppercase text-paper/50">
                {item.medium}{item.year ? ` · ${item.year}` : ""}
              </p>
              {item.story && (
                <p className="mt-6 text-sm font-light leading-relaxed text-paper/70">{item.story}</p>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
